var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useCallback, useEffect } from 'react';
import { EditorState } from 'draft-js';
import { editorStateFromRichTextEditorValue, richTextEditorValueFromEditorState } from './richTextValueUtils';
import { getDecorator } from './decorators';
/*
 * Ideally the value displayed in Rich Text Editor would  come from above the RichTextEditor
 * component and be stored in state there, without any need for local state.
 *
 * Unfortunately we do need additional local state:
 *
 * 1. Value used in App using RichTextEditor must be serializable to allow sending it to/from backend
 * 2. Value used in App should be updated immediately when it changes in Editor, so App can react
 *      how it wants (eg. interactions with other fields, allowing/disallowing save action)
 * 3. Value used by DraftJS is stored in `EditorState`, which is not serializable and contains more
 *      information that app needs (eg. also tracks where cursor is in text, selection state), so we
 *      cannot recreate the `EditorState` on every value update or we would lose this critical info.
 *
 * Therefore we keep `EditorState` locally with its additional selection information, and also update
 *      value in App whenever this local state changes.
 */
export var useLocalEditorState = function (value, setValue, editModeWasActive, referenceCollection) {
    var _a = React.useState(editorStateFromRichTextEditorValue(value, getDecorator())), editorState = _a[0], setEditorStateUNSAFE = _a[1];
    var setEditorState = useCallback(function (nextEditorState) {
        setEditorStateUNSAFE(EditorState.set(nextEditorState, __assign(__assign({}, nextEditorState), { decorator: getDecorator() })));
    }, []);
    useEffect(function () {
        if (editModeWasActive) {
            setValue(richTextEditorValueFromEditorState(editorState, referenceCollection));
        }
    }, [editorState, editModeWasActive]);
    return [editorState, setEditorState];
};
//# sourceMappingURL=useLocalEditorState.js.map